import { takeLatest, put, call, all, fork, select } from "@redux-saga/core/effects";
import { syncFlowIntegrationDependencies } from "redux/actions/portal/resourceDependenciesActionCreator";
import {
   FETCH_FLOW_BY_ID,
   AUTO_CREATE_NEW_FLOW,
   AUTO_UPDATE_CURRENT_FLOW,
   SET_SAVING_FLOW_FLAG_SUCCESS,
   SET_AUTO_SAVING_FLOW_FLAG_SUCCESS,
   SET_SAVING_FLOW_PROPERTIES_FLAG_SUCCESS,
   UPDATE_CURRENT_FLOW,
   UPDATE_CURRENT_FLOW_PROPERTIES,
   CREATE_NEW_FLOW_PROPERTIES,
   UPDATE_FLOW_THUMBNAIL,
   DUPLICATE_FLOW,
   SET_FLOW,
   SHARE_DESIGNER_FLOW,
   UNSHARE_FLOW,
   SET_SHARE_FLOW_FLAG_SUCCESS,
   UPDATE_SHARE_FLOW,
   FETCH_USER_COMMENTS,
   FETCH_DESIGNER_USER_FLOWS,
   FETCH_DESIGNER_FLOWS,
   SET_DESIGNER_USER_FLOWS,
   FETCH_FLOW_VERSIONS,
   UPDATE_FLOW_VERSION,
   SWITCH_FLOW_EDIT_MODE,
    CHANGE_FLOW_MODE,
    VIEW_FLOW_VERSION,
    FETCH_FLOW_CONFIGURATION,
    FETCH_SHARED_FLOW_CONFIGURATIONS,
   SET_SHARED_FLOW_CONFIGURATIONS
} from "redux/constants/flowDesigner";
import {
   setSavedFlow,
   setFlow,
   setFlows,
   setShareFlowFlagReset,
   setUserComments,
   setIsLoadingUserComments,
   setFlowVersions,
   setFlowVersionsIsLoading,
   reloadFlow,
   setFlowIsLoading,
   reloadFlows,
   setFlowConfiguration,
   setSharedFlowConfigurations
} from "redux/actions/flowDesigner/flowsActionCreator";
import { fetchFlowById, createFlow, updateFlow, updateFlowThumbnail, fetchFlows, fetchUserFlows, shareFlow, updateShareFlow, unshareFlow, retrieveJson, getSharedFlowConfigurations } from "api/FlowDesignerApis";
import { getUserCommentsByFlowId, getUserCommentsByNodeId } from "api/userCommentApi";
import { setContext } from "redux/actions/flowDesigner/editorContextActionCreator";
import { toast } from "react-toastify";
import { contextCleanUp } from "layouts/Flow Designer/helpers/common";
import { uploadFile } from "helpers/common";
import { checkCredentialsToShare } from "../portal/flows";
import { openSharerFlowDialog } from "redux/actions/portal/flowsActionCreator";
import { getFlowVersionsByFlowId, updateFlowVersion, insertFlowVersion, changeFlowMode, setFlowVersion } from "api/FlowVersions";
import { executorSocket } from "layouts/Flow Designer/components/Sockets";

/***** WORKERS *****/

function* handleSetFlow(flow, type) {
   if (flow) {
      flow.flow_settings = flow.flow_settings ? JSON.parse(flow.flow_settings) : {};
      yield put(setSavedFlow(flow));

      switch (type) {
         case "regular":
            yield put({ type: SET_SAVING_FLOW_FLAG_SUCCESS });
            break;
         case "props":
            yield put({ type: SET_SAVING_FLOW_PROPERTIES_FLAG_SUCCESS });
            break;
         case "auto":
            yield put({ type: SET_AUTO_SAVING_FLOW_FLAG_SUCCESS });
            break;
         case "duplicate":
      }
   }
   yield put(setFlowIsLoading(false));
}

function* handleFetchFlowById({ payload }) {
   try {
      const { tenant_id, flow_id, version } = payload;
      const res = yield call(fetchFlowById, tenant_id, flow_id, version);

      if (res) {
         if (res.flow_settings) {
            res.flow_settings = res.flow_settings ? JSON.parse(res.flow_settings) : {};
         }

         yield put(setSavedFlow(res));
         let { flow } = yield select((state) => state?.designer?.flows);
         const { name, description, notes, steps, flow_settings } = res;
         const flowSteps = steps?.replace(/,"http"/g, ",http").replace(/,"https"/g, ",https");
         const { nodes, context } = JSON.parse(flowSteps);

         if (context) {
            const cleanedContext = contextCleanUp(context, nodes);
            yield put(setContext(cleanedContext));
         }

         flow = { ...flow, name, description, notes, flow_settings };
         yield put(setFlow(tenant_id, flow));
      }
   } catch (error) {
      console.error(error);
   }
   yield put(setFlowIsLoading(false));
}
function* handleCreateNewFlow({ payload, actionType, user, fromClone }) {
   try {
      const {
         tenant_id,
         input: { logoUpload, ...input }
      } = payload;

      let result = [];

      if (logoUpload?.files?.[0]) {
         result = yield call(uploadFile, user, logoUpload.files?.[0], "flows", input.name, true);
         input.logo = result?.Location;
      }

      const flow = yield call(createFlow, tenant_id, input, actionType !== "auto", fromClone);
      input.tenant_id = tenant_id;
      yield handleSetFlow(Object.assign(flow, input), actionType);
      yield put(
         syncFlowIntegrationDependencies({
            tenantId: tenant_id,
            flowId: flow.id,
            nextIntegrationIds: input.integrations
         })
      );
      yield put(reloadFlows());

      if (window.location.href.includes("designer")) {
         const flows = yield call(fetchFlows, tenant_id);
         yield put(setFlows(flows));
      }
   } catch (error) {
      console.error(error);
   }
}
function* handleUpdateCurrentFlow({ payload, actionType }) {
   try {
      const { tenant_id, flow_id, input, userId } = payload;
      const updateSuccessful = yield call(updateFlow, tenant_id, flow_id, input, actionType !== "auto");

      if (!updateSuccessful) {
         toast.error(`Unable to save modified flow - ensure that an instance of the cxf-executor is running and that the Flow Designer is connected to it. Then, reload and try again.`, {
            autoClose: 5000,
            pauseOnHover: true
         });
         return;
      }

      if (window.location.href.includes("designer") && executorSocket?.connected) {
         executorSocket.emit("flowRoomExecution", { flowId: flow_id, userId, date: new Date().toISOString() });
      }
      input.id = flow_id;
      input.tenant_id = tenant_id;
      yield handleSetFlow(input, actionType);
      if (Object.prototype.hasOwnProperty.call(input, "integrations")) {
         yield put(
            syncFlowIntegrationDependencies({
               tenantId: tenant_id,
               flowId: flow_id,
               nextIntegrationIds: input.integrations
            })
         );
      }
   } catch (error) {
      console.error(error);
   }
}
function* handleUpdateFlowThumbnail({ payload }) {
   try {
      const { tenant_id, flow_id, file } = payload;
      yield call(updateFlowThumbnail, tenant_id, flow_id, file);
   } catch (error) {
      console.error(error);
   }
}
function* handleFetchFlows({ payload }) {
   try {
      const { tenant_id } = payload;
      const res = yield call(fetchFlows, tenant_id);
      yield put(setFlows(res));
   } catch (error) {
      console.error(error);
   }
}
export function* handleFetchUserFlows({ payload }) {
   try {
      const { tenant_id } = payload;
      const flows = yield call(fetchUserFlows, tenant_id);
      if (flows) {
         yield put({ type: SET_DESIGNER_USER_FLOWS, payload: flows });
      }
   } catch (error) {
      console.error(error);
   }
}

function* handleShareFlow({ payload }) {
   try {
      const { tenant_id, input } = payload;
      const { user_flows } = input;
      const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
      const hasCredentials = yield checkCredentialsToShare({
         tenant_id,
         toShareFlows: user_flows,
         flow: currentSavedFlow
      });

      yield put(setShareFlowFlagReset());

      const res = yield call(shareFlow, tenant_id, input);

      if (res.isSuccessful) {
         if (hasCredentials) {
            yield put(openSharerFlowDialog());
         }
         yield put({ type: SET_SHARE_FLOW_FLAG_SUCCESS });
         toast.success(`Flow shared successfully`);
      }
   } catch (error) {
      console.error(error);
      toast.success(`Unable to share the flow`);
   }
}
function* handleUnshareFlow({ payload }) {
   try {
      const { tenant_id, user_id } = payload;
      const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
      const { userFlows } = yield select((state) => state?.designer?.flows);
      const userFlowsByFlowId = userFlows?.filter((uf) => uf.flow_id === currentSavedFlow?.id);
      const targetUserFlow = userFlowsByFlowId?.find((uf) => uf.user_id === user_id);
      if (targetUserFlow) {
         yield call(unshareFlow, tenant_id, [targetUserFlow.id]);
         toast.success(`Flow unshared successfully`);
      }
   } catch (error) {
      console.error(error);
      toast.success(`Unable to unshare the flow`);
   }
}
function* handleUpdateShareFlow({ payload }) {
   try {
      const { tenant_id, user_id, access_type } = payload;
      const apiPayload = { user_flows: [] };
      const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
      const { userFlows } = yield select((state) => state?.designer?.flows);
      const userFlowsByFlowId = userFlows?.filter((uf) => uf.flow_id === currentSavedFlow?.id);
      userFlowsByFlowId.forEach((userFlow) => {
         const { tenant_id: _tenantId, ...userFlowInput } = userFlow;
         apiPayload.user_flows.push({
            ...userFlowInput,
            access_type: userFlow.user_id === user_id ? access_type : userFlow.access_type
         });
      });

      const updatedUserFlows = yield call(updateShareFlow, tenant_id, apiPayload);
      if (updatedUserFlows) {
         yield put({ type: SET_SHARE_FLOW_FLAG_SUCCESS });
         toast.success(`Access type updated successfully`);
      }
   } catch (error) {
      console.error(error);
      toast.error(`Unable to share the flow`);
   }
}
function* handleFetchUserComments({ payload }) {
   try {
      const { tenant_id, flow_id, node_id } = payload;
      let res;
      yield put(setIsLoadingUserComments(true));

      if (node_id) {
         res = yield call(getUserCommentsByNodeId, tenant_id, flow_id, node_id);
      } else {
         res = yield call(getUserCommentsByFlowId, tenant_id, flow_id);
      }

      if (res?.resultObject) {
         yield put(setUserComments(res.resultObject));
      }
   } catch (error) {
      console.error(error);
   }

   yield put(setIsLoadingUserComments(false));
}

function* handleFetchFlowVersions({ payload }) {
   try {
      const { flow_id } = payload;
      const res = yield call(getFlowVersionsByFlowId, flow_id);

      yield put(setFlowVersionsIsLoading(true));
      if (res?.isSuccessful) {
         yield put(setFlowVersions(res?.resultObject || []));
      }
   } catch (error) {
      console.error(error);
   }
   yield put(setFlowVersionsIsLoading(false));
}

function* handleUpdateFlowVersion({ payload }) {
   try {
      const { flowVersions, currentSavedFlow } = yield select((state) => state?.designer?.flows);

      if ((currentSavedFlow.shared_status === "test" && payload.status === "reset") || payload.status === "active" || payload.status === "inactive") {
         yield put(setFlowIsLoading(true));
      }

      const res = yield call(updateFlowVersion, payload);

      if (res?.isSuccessful) {
         let updatedFlowVersions = flowVersions;
         if (payload.status === "reset") {
            updatedFlowVersions = flowVersions.map((version) => {
               if (version.id === payload.id) {
                  return { ...payload };
               }
               return version;
            });
         }

         if (payload.status === "active") {
            updatedFlowVersions = flowVersions.map((version) => (version.status === "active" ? { ...version, status: "inactive" } : version));

            updatedFlowVersions = updatedFlowVersions.map((version) => (payload?.id === version.id ? { ...version, status: payload?.status, steps: payload?.steps } : version));
         }

         if (payload.status === "inactive") {
            const fetchFlowVersionResponse = yield call(getFlowVersionsByFlowId, payload.flow_id);
            updatedFlowVersions = fetchFlowVersionResponse?.resultObject?.sort((a, b) => b.version - a.version);
         }
         yield put(setFlowVersions(updatedFlowVersions));
         if (payload.status === "active" || (payload.status === "reset" && currentSavedFlow.shared_status === "test") || payload.status === "inactive") yield put(setFlowVersions(updatedFlowVersions));

         yield put(setSavedFlow({ ...currentSavedFlow, steps: payload?.steps, shared_status: payload?.status === "draft" ? "test" : payload?.status, current_version: payload?.version }));

         yield put(reloadFlow());
      }
   } catch (error) {
      console.error(error);
   }
   yield put(setFlowIsLoading(false));
}

function* handleSwitchFlowEditMode({ payload }) {
   try {
      const { tenant_id } = payload;
      const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
      yield put(setFlowIsLoading(true));
      const res = yield call(insertFlowVersion, tenant_id, currentSavedFlow.id, currentSavedFlow.name);
      if (res.isSuccessful) {
         yield handleFetchFlowVersions({ payload: { tenant_id, flow_id: currentSavedFlow.id } });

         yield put(
            setSavedFlow({ ...currentSavedFlow, steps: res?.resultObject?.steps, shared_status: res?.resultObject?.status === "draft" ? "test" : res?.resultObject?.status, current_version: res?.resultObject?.version })
         );

         yield put(reloadFlow());
      }
   } catch (error) {
      console.error(error);
   }
   yield put(setFlowIsLoading(false));
}

function* handleChangeFlowMode({ payload }) {
   try {
      const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
      const { tenant_id, flow_id, mode } = payload;
      yield put(setFlowIsLoading(true));

      const res = yield call(changeFlowMode, tenant_id, flow_id, mode);
      const flowVersions = yield call(getFlowVersionsByFlowId, flow_id);

      if (res?.isSuccessful) {
         yield put(setFlowVersions(flowVersions?.resultObject?.sort((a, b) => b.version - a.version)));
         yield put(setSavedFlow({ ...currentSavedFlow, shared_status: mode === "draft" ? "test" : "active", steps: res?.resultObject?.steps, current_version: res?.resultObject?.version }));

         yield put(reloadFlow());
      }
   } catch (error) {
      console.error(error);
   }
   yield put(setFlowIsLoading(false));
}

function* handleViewFlowVersion({ payload }) {
   try {
      const { tenant_id, flow_version } = payload;
      const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
      yield put(setFlowIsLoading(true));

      const res = yield call(setFlowVersion, { ...flow_version, tenant_id });

      if (res.isSuccessful && res.resultObject) {
         yield put(setSavedFlow({ ...currentSavedFlow, shared_status: res.resultObject.shared_status, steps: res.resultObject.steps, current_version: res.resultObject.current_version }));

         yield put(reloadFlow());
      }
   } catch (error) {
      console.error(error);
   }
   yield put(setFlowIsLoading(false));
}

function* handleFetchFlowConfiguration() {
   yield select((state) => state?.designer?.editorContext);
   const { currentSavedFlow } = yield select((state) => state?.designer?.flows);

   if (!currentSavedFlow) return;

   const { tenant_id, id, current_version, flow_settings } = currentSavedFlow;
   const parsedFlowSettings = flow_settings ? (typeof flow_settings === "string" ? JSON.parse(flow_settings) : flow_settings) : {};

   if (!parsedFlowSettings.hasFlowConfiguration) {
      yield put(setFlowConfiguration({}));
      return;
   }

   try {
      const flowConfigurationKey = `${tenant_id}-${id}-${current_version}-config`;
      const res = yield call(retrieveJson, flowConfigurationKey);
      const flow_configuration = res?.resultObject ?? {};
      yield put(setFlowConfiguration(flow_configuration));
   } catch (error) {
      console.error(error);
   }
}

function* handleFetchSharedFlowConfigurations() {
   const { currentSavedFlow } = yield select((state) => state?.designer?.flows);
   if (!currentSavedFlow?.tenant_id) return;

   let flowSettings = {};
   try {
      flowSettings = currentSavedFlow.flow_settings
         ? typeof currentSavedFlow.flow_settings === "string"
            ? JSON.parse(currentSavedFlow.flow_settings)
            : currentSavedFlow.flow_settings
         : {};
   } catch (error) {
      console.error(error);
   }
   const configurationKeys = Array.isArray(flowSettings.sharedFlowConfigurationKeys)
      ? flowSettings.sharedFlowConfigurationKeys
      : [];

   if (!flowSettings.hasSharedFlowConfigurations || configurationKeys.length === 0) {
      yield put(setSharedFlowConfigurations({}));
      return;
   }

   try {
      const response = yield call(getSharedFlowConfigurations, currentSavedFlow.tenant_id, configurationKeys);
      const sharedFlowConfigurations = response?.isSuccessful ? response.resultObject ?? {} : {};
      yield put(setSharedFlowConfigurations(sharedFlowConfigurations));
   } catch (error) {
      console.error(error);
      yield put(setSharedFlowConfigurations({}));
   }
}

function* handleSetSharedFlowConfigurations({ payload }) {
   const { context } = yield select((state) => state?.designer?.editorContext);
   const valuesByConfigurationKey = Object.fromEntries(Object.entries(payload ?? {}).map(([configurationKey, configuration]) => [configurationKey, configuration?.values ?? {}]));

   yield put(setContext({ ...context, shared_flow_configurations: valuesByConfigurationKey }));
}

/***** WATCHERS *****/

function* watchFetchFlows() {
   yield takeLatest(FETCH_DESIGNER_FLOWS, handleFetchFlows);
}
function* watchFetchUserFlows() {
   yield takeLatest(FETCH_DESIGNER_USER_FLOWS, handleFetchUserFlows);
}
function* watchSetFlow() {
   yield takeLatest(SET_FLOW, handleFetchFlows);
}
function* watchGetFlowById() {
   yield takeLatest(FETCH_FLOW_BY_ID, handleFetchFlowById);
}
function* watchCreateNewFlow() {
   yield takeLatest([CREATE_NEW_FLOW_PROPERTIES, AUTO_CREATE_NEW_FLOW, DUPLICATE_FLOW], handleCreateNewFlow);
}
function* watchUpdateCurrentFlow() {
   yield takeLatest([UPDATE_CURRENT_FLOW, UPDATE_CURRENT_FLOW_PROPERTIES, AUTO_UPDATE_CURRENT_FLOW], handleUpdateCurrentFlow);
}
function* watchUpdateFlowThumbnail() {
   yield takeLatest(UPDATE_FLOW_THUMBNAIL, handleUpdateFlowThumbnail);
}

function* watchShareFlow() {
   yield takeLatest(SHARE_DESIGNER_FLOW, handleShareFlow);
}
function* watchUnshareFlow() {
   yield takeLatest(UNSHARE_FLOW, handleUnshareFlow);
}
function* watchUpdateShareFlow() {
   yield takeLatest(UPDATE_SHARE_FLOW, handleUpdateShareFlow);
}
function* watchFetchUserComments() {
   yield takeLatest(FETCH_USER_COMMENTS, handleFetchUserComments);
}
function* watchFetchFlowVersions() {
   yield takeLatest(FETCH_FLOW_VERSIONS, handleFetchFlowVersions);
}
function* watchUpdateFlowVersion() {
   yield takeLatest(UPDATE_FLOW_VERSION, handleUpdateFlowVersion);
}
function* watchSwitchFlowEditMode() {
   yield takeLatest(SWITCH_FLOW_EDIT_MODE, handleSwitchFlowEditMode);
}

function* watchChangeFlowMode() {
   yield takeLatest(CHANGE_FLOW_MODE, handleChangeFlowMode);
}
function* watchViewFlowVersion() {
   yield takeLatest(VIEW_FLOW_VERSION, handleViewFlowVersion);
}
function* watchFetchFlowConfiguration() {
   yield takeLatest(FETCH_FLOW_CONFIGURATION, handleFetchFlowConfiguration);
}
function* watchFetchSharedFlowConfigurations() {
   yield takeLatest(FETCH_SHARED_FLOW_CONFIGURATIONS, handleFetchSharedFlowConfigurations);
}
function* watchSetSharedFlowConfigurations() {
   yield takeLatest(SET_SHARED_FLOW_CONFIGURATIONS, handleSetSharedFlowConfigurations);
}

export function* rootFlowsSaga() {
   yield all([
      fork(watchSetFlow),
      fork(watchFetchFlows),
      fork(watchGetFlowById),
      fork(watchCreateNewFlow),
      fork(watchUpdateCurrentFlow),
      fork(watchUpdateFlowThumbnail),

      fork(watchFetchUserFlows),
      fork(watchShareFlow),
      fork(watchUnshareFlow),
      fork(watchUpdateShareFlow),
      fork(watchFetchUserComments),
      fork(watchFetchFlowVersions),
      fork(watchUpdateFlowVersion),
      fork(watchSwitchFlowEditMode),
      fork(watchChangeFlowMode),
       fork(watchViewFlowVersion),
       fork(watchFetchFlowConfiguration),
       fork(watchFetchSharedFlowConfigurations),
      fork(watchSetSharedFlowConfigurations)
   ]);
}
